import { render, staticRenderFns } from "./RepList.vue?vue&type=template&id=6dd97266&scoped=true&"
import script from "./RepList.vue?vue&type=script&lang=ts&"
export * from "./RepList.vue?vue&type=script&lang=ts&"
import style0 from "./RepList.vue?vue&type=style&index=0&id=6dd97266&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6dd97266",
  null
  
)

export default component.exports